"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StyledButton_1 = tslib_1.__importDefault(require("../buttons/StyledButton"));
const fmko_ts_common_1 = require("fmko-ts-common");
const InfoPanelOptions_1 = require("./InfoPanelOptions");
const Div_1 = tslib_1.__importDefault(require("../elements/Div"));
const ButtonStyle_1 = tslib_1.__importDefault(require("../buttons/ButtonStyle"));
const ImageWidget_1 = tslib_1.__importDefault(require("../widget/ImageWidget"));
class InfoPanel extends fmko_ts_common_1.Widget {
    constructor(infoPanelOptions, ...buttons) {
        super();
        this.infoPanelOptions = infoPanelOptions;
        this.infoPanelSeverity = InfoPanelOptions_1.InfoPanelSeverity.INFO;
        this.buttons = buttons;
        this.element = document.createElement("div");
        this.element.classList.add("info-box");
        this.render();
    }
    reRender(infoPanelOptions, ...buttons) {
        this.clearHTMLChildren();
        this.infoPanelOptions = { ...this.infoPanelOptions, ...infoPanelOptions };
        if (buttons?.length) {
            this.buttons = buttons;
        }
        this.render();
    }
    clearHTMLChildren() {
        super.clearHTMLChildren();
        this.imgAndDescriptionContainer = null;
    }
    render() {
        this.renderImage();
        this.renderDescription();
        this.renderButtons();
        if (this.infoPanelOptions.testIdentifier) {
            this.element.dataset.cy = this.infoPanelOptions.testIdentifier;
        }
    }
    getInfoPanelSeverity() {
        return this.infoPanelSeverity;
    }
    renderImage() {
        this.renderImageAndTextContainer();
        const { imageOptions } = this.infoPanelOptions;
        if (imageOptions) {
            const { alt, imageSize, src } = imageOptions;
            const imageWidget = new ImageWidget_1.default({
                alt,
                imageDimension: imageSize,
                src
            });
            const imageContainer = new Div_1.default();
            imageContainer.element.classList.add("info-box-img");
            imageContainer.add(imageWidget);
            this.imgAndDescriptionContainer.appendChild(imageContainer.element);
        }
    }
    renderDescription() {
        this.renderImageAndTextContainer();
        this.descriptionContainer = new Div_1.default();
        this.descriptionContainer.addCssClass("info-box-text");
        if (this.infoPanelOptions.imageOptions) {
            this.descriptionContainer.addCssClass("with-image");
        }
        this.descriptionContainer.removeCssClass(InfoPanelOptions_1.InfoPanelSeverity.INFO, InfoPanelOptions_1.InfoPanelSeverity.WARNING, InfoPanelOptions_1.InfoPanelSeverity.ERROR);
        const { description, dangerousHTML, severity, ariaLive = "off" } = this.infoPanelOptions;
        if (dangerousHTML) {
            this.descriptionContainer.setHTML(dangerousHTML);
        }
        else {
            this.descriptionContainer.setText(description || "");
        }
        this.descriptionContainer.element.setAttribute(fmko_ts_common_1.ARIA.LIVE, ariaLive);
        this.infoPanelSeverity = severity || InfoPanelOptions_1.InfoPanelSeverity.INFO;
        this.imgAndDescriptionContainer.classList.add(this.infoPanelSeverity);
        this.imgAndDescriptionContainer.appendChild(this.descriptionContainer.element);
    }
    renderButtons() {
        const buttonContainer = new Div_1.default();
        buttonContainer.addCssClass("info-box-button");
        for (const button of (this.buttons || [])) {
            button.setStyle(this.mapInfoPanelWarningToButtonStyle(this.infoPanelOptions.severity));
            button.setAnimateHover(false);
            buttonContainer.add(button);
        }
        if (this.infoPanelOptions.expandButton) {
            const detailsButton = new StyledButton_1.default({
                animateHover: false,
                clickHandler: () => {
                    const { dialogManager, dialogContent, dialogWidth } = this.infoPanelOptions.expandButton();
                    // @ts-ignore - This is fine, you can await void types
                    dialogManager.showAsync(dialogContent, {
                        dialogWidth: dialogWidth || fmko_ts_common_1.DialogWidth.FULL,
                        title: this.descriptionContainer.getText()
                    });
                },
                style: this.mapInfoPanelWarningToButtonStyle(this.infoPanelOptions.severity),
                text: "Detaljer"
            });
            const expandImageContainer = new Div_1.default();
            expandImageContainer.addCssClass("info-box-expand-container");
            expandImageContainer.add(detailsButton);
            buttonContainer.add(expandImageContainer);
        }
        this.add(buttonContainer);
    }
    renderImageAndTextContainer() {
        if (!this.imgAndDescriptionContainer) {
            this.imgAndDescriptionContainer = document.createElement("div");
            this.imgAndDescriptionContainer.classList.add("info-box-img-and-text");
            this.add(this.imgAndDescriptionContainer);
        }
    }
    mapInfoPanelWarningToButtonStyle(infoPanelSeverity) {
        if (!infoPanelSeverity) {
            return ButtonStyle_1.default.SMALL_GREY_BORDERLESS;
        }
        switch (infoPanelSeverity) {
            case InfoPanelOptions_1.InfoPanelSeverity.INFO:
                return ButtonStyle_1.default.SMALL_GREY_BORDERLESS;
            case InfoPanelOptions_1.InfoPanelSeverity.WARNING:
                return ButtonStyle_1.default.SMALL_WARNING_BORDERLESS;
            case InfoPanelOptions_1.InfoPanelSeverity.ERROR:
                return ButtonStyle_1.default.SMALL_ERROR_BORDERLESS;
        }
    }
}
exports.default = InfoPanel;
//# sourceMappingURL=InfoPanel.js.map